import { Fragment, type ReactNode } from 'react'
import { displayKeys } from '../logic/hotkeys.ts'
import { cx } from './cx.ts'

export function Kbd({ children, className }: { children: ReactNode; className?: string }) {
  return <kbd className={cx('rt-kbd', className)}>{children}</kbd>
}

/** Renders a binding (`mod+k`, `g h`) as keycaps: ⌘ K on Apple, Ctrl K elsewhere; "then" between steps. */
export function Keys({ keys, className }: { keys: string; className?: string }) {
  const steps = displayKeys(keys)
  return (
    <span className={cx('rt-kbds', className)} aria-label={steps.map((s) => s.join('+')).join(' then ')}>
      {steps.map((step, i) => (
        <Fragment key={i}>
          {i > 0 ? <span aria-hidden>then</span> : null}
          {step.map((k, j) => (
            <kbd key={j} className="rt-kbd" aria-hidden>
              {k}
            </kbd>
          ))}
        </Fragment>
      ))}
    </span>
  )
}
